import React from "react";
import { Col, Form, InputNumber } from "antd";
import InjectionMouldlingFields from "./injectionMouldlingFields";
import ExtrutionFields from "./extrutionFields";
import PunchPressFields from "./punchPressFields";
import CncFields from "./cncMetaFields";

const PartMetaInputs = ({ templateType, form }) => {
  switch (templateType) {
    case 4:
      return (
        <CncFields prefix={"meta"} />
      )
    case 3:
      return (
        <PunchPressFields prefix={"meta"} />
      );
    case 2:
      return (
        <ExtrutionFields prefix={"meta"} />
      );
    case 1:
      return (
        <InjectionMouldlingFields prefix={"meta"} form={form}/>
      );
  }
};

export default PartMetaInputs;
